// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-issue-seller-invoice-register',
//   standalone: true,
//   imports: [],
//   templateUrl: './issue-seller-invoice-register.component.html',
//   styleUrl: './issue-seller-invoice-register.component.scss'
// })
// export class IssueSellerInvoiceRegisterComponent {

// }
import { formatDate } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { ToWords } from 'to-words';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-issue-seller-invoice-register',
  templateUrl: './issue-seller-invoice-register.component.html',
  styleUrls: ['./issue-seller-invoice-register.component.scss'],
})
export class IssueSellerInvoiceRegisterComponent implements OnInit {
  startDate;
  endDate;
  today;
  issueName;
  issueDates;
  reportType;
  advtInvoiceData;
  filteredAdvtInvoiceData: any;
  isLoading = false;
  printShowData = [];
  filteredPrintShowData = [];
  sdate: any;
  enddate: any;
  invoiceNumber: any;
  issuedate: any;
  invoiceName: any;
  advtamount: any;
  discountamt: any;
  netamount: any;
  gstcst: any;
  totalinvoiceamount: any;
  paidamount: any;
  filteredAdvtInvoiceDatamonthly: any;
  netamountm: any;
  advtamountm: any;
  gstcstm: any;
  paidamountm: any;
  filteredAdvtInvoiceDatabrifly: any;
  beforegst: any;
  tcgst: any;
  tsgst: any;
  tigst: any;
  tgst: any;
  totalamount: any;
  cgst: number;
  sgst: number;
  igst: number;
  showData: any;
  receivedamt: number;
  pendingamt: number;
  totals: { first_week_amount: number; second_week_amount: number; third_week_amount: number; fourth_week_amount: number; fifth_week_amount: number; first_week_cgst: number; second_week_cgst: number; third_week_cgst: number; fourth_week_cgst: number; fifth_week_cgst: number; first_week_sgst: number; second_week_sgst: number; third_week_sgst: number; fourth_week_sgst: number; fifth_week_sgst: number; first_week_igst: number; second_week_igst: number; third_week_igst: number; fourth_week_igst: number; fifth_week_igst: number; pay_amt: number; issue_selling_discount_amt: number; net_amount: number; gst_amount: number; received_amt: number; total_invoice_amt: number; };
  dataList: any;
  beforegst1: number;
  tcgst1: number;
  tigst1: number;
  tsgst1: number;
  tgst1: number;
  discountamt1: number;
  receivedamt1: number;
  pendingamt1: number;
  totalamount1: number;
  netamount1: number;
  amount1: number;
  secondweek: number;
  thirdweek: number;
  fourthweek: number;
  fifthweek: number;
  firstweek: number;
  beforegst11: number;
  discountamt3: number;
  paidamount1: number;
  cgst4: number;
  igst4: number;
  sgst4: number;
  totalamount2: number;
  issueamt: number;
  filteredrniInvoiceDatabrifly: any;
  monthWiseRNIData: unknown[];
  grandW1: number;
  grandW3: number;
  grandW2: number;
  grandW4: number;
  grandW5: number;
  grandCopies: number;
  grandAmt: number;
  grandOpening: number;
  grandDisc: number;
  grandCW2: number;
  grandCW1: number;
  grandCW4: number;
  grandCW3: number;
  grandCW5: number;
  grandCCopies: number;


  constructor(
    private dialogRef: MatDialogRef<IssueSellerInvoiceRegisterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }

  ngOnInit(): void {

    this.isLoading = false;
    this.today = new Date();
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    this.issueName = this.data['issueName'];
    this.issueDates = this.data['issueDates'];
    this.reportType = this.data['reportType'];
    this.sdate = this.data['startDate'];
    this.enddate = this.data['endDate'];
    this.invoiceName = this.data['issueName'];
    this.issuedate = this.data['issueDates'];
    // this.advtInvoiceData = this.data['advtData'];
    // console.log(this.data);

    console.log(this.sdate, this.enddate, this.invoiceName, this.issuedate, "data");

    this.getData();
  }


  getData() {


    const req: any = {
      "start_date": this.sdate,
      "end_date": this.enddate,
      "issue_name": this.issueName,
      "issue_date": this.issueDates,

    }
    this.service.getissueInvoiceRegisterList(req).subscribe((res: any) => {
      console.log(res);
      this.filteredAdvtInvoiceData = res;
      this.advtamount = 0;
      this.discountamt3 = 0;
      this.netamount = 0;
      this.cgst4 = 0;
      this.sgst4 = 0;
      this.igst4 = 0;
      this.gstcst = 0;
      this.totalinvoiceamount = 0;
      this.paidamount1 = 0;
      this.secondweek = 0;
      this.thirdweek = 0;
      this.fourthweek = 0;
      this.fifthweek = 0;
      this.firstweek = 0;
      this.beforegst11 = 0;
      this.issueamt = 0;
      for (let data1 of this.filteredAdvtInvoiceData) {
        console.log(data1.advt_amt, "advt amt")
        this.firstweek += parseInt(data1.first_week_amount) || 0;
        this.secondweek += parseInt(data1.second_week_amount) || 0;
        this.thirdweek += parseInt(data1.third_week_amount) || 0;
        this.fourthweek += parseInt(data1.fourth_week_amount) || 0;
        this.fifthweek += parseInt(data1.fifth_week_amount) || 0;
        this.advtamount += parseInt(data1.pay_amt) || 0;
        this.issueamt += parseInt(data1.issue_selling_amount) || 0;
        this.discountamt3 += parseInt(data1.issue_selling_discount_amt) || 0;
        // this.netamount += parseInt(data1.issue_selling_discount_amt) || 0;

        this.cgst4 += +(data1.first_week_cgst || 0) + +(data1.second_week_cgst || 0) + +(data1.third_week_cgst || 0) + +(data1.fourth_week_cgst || 0) +
          +(data1.fifth_week_cgst || 0);
        this.sgst4 += +(data1.first_week_sgst || 0) + +(data1.second_week_sgst || 0) + +(data1.third_week_sgst || 0) + +(data1.fourth_week_sgst || 0) +
          +(data1.fifth_week_sgst || 0);
        this.igst4 += +(data1.first_week_igst || 0) + +(data1.second_week_igst || 0) + +(data1.third_week_igst || 0) + +(data1.fourth_week_igst || 0) +
          +(data1.fifth_week_igst || 0);

        this.totalinvoiceamount += parseInt(data1.total_invoice_amt) || 0;
        this.paidamount1 += parseInt(data1.received_amt) || 0;
        this.beforegst11 += parseInt(data1.net_amount) || 0;
      }
      console.log(this.advtamount, "total advt")
      console.log("inovice register data", this.filteredAdvtInvoiceData)
    });

    this.service.getIssuesaleInvoiceRegisterListmonthly(req).subscribe((res: any) => {
      console.log(res);
      this.filteredAdvtInvoiceDatamonthly = res;

      this.beforegst1 = 0;
      this.tcgst1 = 0;
      this.tsgst1 = 0;
      this.tigst1 = 0;
      this.tgst1 = 0;
      this.totalamount1 = 0;
      this.discountamt1 = 0;
      this.receivedamt1 = 0;
      this.pendingamt1 = 0;
      this.netamount1 = 0;
      this.amount1 = 0;
      for (let data1 of this.filteredAdvtInvoiceDatamonthly) {

        this.tcgst1 += parseInt(data1.cgst) || 0;
        this.tsgst1 += parseInt(data1.sgst) || 0;
        this.tigst1 += parseInt(data1.igst) || 0;
        this.tgst1 += parseInt(data1.gst) || 0;
        this.beforegst1 += parseInt(data1.beforegst_amt) || 0;
        this.totalamount1 += parseInt(data1.issue_amt) || 0;
        this.discountamt1 += parseInt(data1.discount) || 0;
        this.receivedamt1 += parseInt(data1.received_amt) || 0;
        this.pendingamt1 += parseInt(data1.pending_amt) || 0;
        this.netamount1 += parseInt(data1.net_amount) || 0;
        this.amount1 += parseInt(data1.amount) || 0;
      }
      console.log("inovice register data", this.filteredAdvtInvoiceDatamonthly)
    });





    this.service.getissueInvoiceRegisterListbriefly(req).subscribe((res: any) => {
      console.log(res);
      this.filteredAdvtInvoiceDatabrifly = res;
      this.beforegst = 0;
      this.tcgst = 0;
      this.tsgst = 0;
      this.tigst = 0;
      this.tgst = 0;
      this.totalamount = 0;
      this.discountamt = 0;
      this.receivedamt = 0;
      this.pendingamt = 0;
      this.totalamount2 = 0;
      for (let data1 of this.filteredAdvtInvoiceDatabrifly) {

        this.tcgst += parseInt(data1.cgst) || 0;
        this.tsgst += parseInt(data1.sgst) || 0;
        this.tigst += parseInt(data1.igst) || 0;
        this.tgst += parseInt(data1.gst) || 0;
        this.beforegst += parseInt(data1.beforegst_amt) || 0;
        this.totalamount += parseInt(data1.amount) || 0;
        this.totalamount2 += parseInt(data1.issue_amt) || 0;
        this.discountamt += parseInt(data1.discount) || 0;
        this.receivedamt += parseInt(data1.received_amt) || 0;
        this.pendingamt += parseInt(data1.pending_amt) || 0;
      }
      console.log("inovice register data", this.filteredAdvtInvoiceDatabrifly)
    });


   this.service.getissueInvoiceRegisterListrni(req).subscribe((res: any) => {
  console.log(res);
  debugger;

  // Reset grand totals
  this.grandAmt = this.grandDisc = this.grandOpening = 0;
  this.grandW1 = this.grandW2 = this.grandW3 = this.grandW4 = this.grandW5 = 0;
  this.grandCopies = 0;
  this.grandCW1 = this.grandCW2 = this.grandCW3 = this.grandCW4 = this.grandCW5 = 0;
  this.grandCCopies = 0;

  // Group by Month
  const grouped: any = {};

  for (let data of res) {
    // ✅ Format month and year in Marathi
    const monthName = new Date(data.invoice_date).toLocaleString('mr-IN', {
      month: 'long',
      year: 'numeric'
    });

    if (!grouped[monthName]) {
      grouped[monthName] = {
        monthName,
        invoices: [],
        totalW1: 0,
        totalW2: 0,
        totalW3: 0,
        totalW4: 0,
        totalW5: 0,
        totalCW1: 0,
        totalCW2: 0,
        totalCW3: 0,
        totalCW4: 0,
        totalCW5: 0,
        totalCCopies: 0, // ✅ Added this initialization
        totalCopies: 0,
        totalAmt: 0,
        totalDisc: 0,
        totalOpening: 0
      };
    }

    // Push invoice into month
    grouped[monthName].invoices.push(data);

    // Update month totals
    grouped[monthName].totalW1 += +data.week1_copies || 0;
    grouped[monthName].totalW2 += +data.week2_copies || 0;
    grouped[monthName].totalW3 += +data.week3_copies || 0;
    grouped[monthName].totalW4 += +data.week4_copies || 0;
    grouped[monthName].totalW5 += +data.week5_copies || 0;
    grouped[monthName].totalCopies += +data.total_week_copies || 0;

    grouped[monthName].totalCW1 += +data.week1_com_copies || 0;
    grouped[monthName].totalCW2 += +data.week2_com_copies || 0;
    grouped[monthName].totalCW3 += +data.week3_com_copies || 0;
    grouped[monthName].totalCW4 += +data.week4_com_copies || 0;
    grouped[monthName].totalCW5 += +data.week5_com_copies || 0;
    grouped[monthName].totalCCopies += +data.total_week_com_copies || 0;

    grouped[monthName].totalAmt += +data.total_amount || 0;
    grouped[monthName].totalDisc += +data.total_discount || 0;
    grouped[monthName].totalOpening += +data.opening_bal || 0;

    // Update grand totals
    this.grandW1 += +data.week1_copies || 0;
    this.grandW2 += +data.week2_copies || 0;
    this.grandW3 += +data.week3_copies || 0;
    this.grandW4 += +data.week4_copies || 0;
    this.grandW5 += +data.week5_copies || 0;
    this.grandCopies += +data.total_week_copies || 0;

    this.grandCW1 += +data.week1_com_copies || 0;
    this.grandCW2 += +data.week2_com_copies || 0;
    this.grandCW3 += +data.week3_com_copies || 0;
    this.grandCW4 += +data.week4_com_copies || 0;
    this.grandCW5 += +data.week5_com_copies || 0;
    this.grandCCopies += +data.total_week_com_copies || 0; // ✅ Correct accumulation

    this.grandAmt += +data.total_amount || 0;
    this.grandDisc += +data.total_discount || 0;
    this.grandOpening += +data.opening_bal || 0;
  }

  // Convert grouped data to array for *ngFor
  this.monthWiseRNIData = Object.values(grouped);

  console.log("Month-wise RNI Report Data", this.monthWiseRNIData);
});



  }



  filterData() {
    // console.log('called');
    if (this.startDate == '' && this.endDate == '') {
      this.advtInvoiceData = this.filteredAdvtInvoiceData;
      // console.log('filteredData', this.advtInvoiceData);
    } else if (this.startDate !== '' && this.endDate !== '') {
      this.advtInvoiceData = this.filteredAdvtInvoiceData.filter((a) => {
        return (
          a['invoice_date'] >= this.startDate &&
          a['invoice_date'] <= this.endDate
        );
      });
      // console.log('filteredData', this.advtInvoiceData);
    }

    setTimeout(() => {
      this.setData();
    }, 700);
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  setData() {
    // console.log(this.advtInvoiceData);
    // console.log(this.advtInvoiceData);
    if (this.advtInvoiceData.length == 0) {
      this.isLoading = false;
      alert('Data is not Present.');
      this.dialogRef.close();
    }
    let data = this.uniqueid(this.advtInvoiceData, (a) => a.advt_name);
    // console.log(data);
    for (let index = 0; index < this.advtInvoiceData.length; index++) {
      // let eachData = this.advtInvoiceData.filter(
      //   (a) => data[i]['advt_name'] == a.advt_name
      // );

      let showData = {
        issue_name: '',
        invoice_no: '',
        invoice_date: '',
        advt_name: '',
        client_name: '',
        rep_name: '',
        off_rep_name: '',
        firstweek_issue_date: '',
        secondweek_issue_date: '',
        thirdweek_issue_date: '',
        fourthweek_issue_date: '',
        fifthweek_issue_date: '',
        total_advt_amt: 0,
        total_dis: 0,
        total_net: 0,
        total_cgst: 0,
        total_sgst: 0,
        total_igst: 0,
        total_amt: 0,
        total: 0,
      };

      // if (Object.keys(eachData).length > 0) {
      console.log('called', this.advtInvoiceData);
      // for (let index = 0; index < this.advtInvoiceData.length; index++) {
      if (
        this.advtInvoiceData[index]['first_week_id'] != null &&
        this.advtInvoiceData[index]['first_week_issue_name'] ===
        this.issueName &&
        this.issueDates.includes(
          this.advtInvoiceData[index]['first_week_issue_date']
        )
      ) {
        // console.log('first');
        showData['issue_name'] =
          this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
        console.log(showData['issue_name'], "new issue name");

        showData['firstweek_issue_date'] =
          this.advtInvoiceData[index]['first_week_issue_date'].split(',')[0];
        showData['total_advt_amt'] += parseInt(
          this.advtInvoiceData[index]['first_week_advt_amt']
        );
        showData['total_dis'] += parseInt(
          this.advtInvoiceData[index]['first_week_advt_discnt']
        );
        showData['total_net'] += parseInt(
          this.advtInvoiceData[index]['first_week_amount']
        );
        showData['total_cgst'] += parseInt(
          this.advtInvoiceData[index]['first_week_cgst']
        );
        showData['total_sgst'] += parseInt(
          this.advtInvoiceData[index]['first_week_sgst']
        );
        showData['total_igst'] += parseInt(
          this.advtInvoiceData[index]['first_week_igst']
        );
        showData['total_amt'] += parseInt(
          this.advtInvoiceData[index]['first_week_total_amount']
        );
      } else if (
        this.advtInvoiceData[index]['second_week_id'] != null &&
        this.advtInvoiceData[index]['second_week_issue_name'] ===
        this.issueName &&
        this.issueDates.includes(
          this.advtInvoiceData[index]['second_week_issue_date']
        )
      ) {
        showData['issue_name'] =
          this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
        showData['secondweek_issue_date'] =
          this.advtInvoiceData[index]['second_week_issue_date'].split(',')[0];
        showData['total_advt_amt'] += parseInt(
          this.advtInvoiceData[index]['second_week_advt_amt']
        );
        showData['total_dis'] += parseInt(
          this.advtInvoiceData[index]['second_week_advt_discnt']
        );
        showData['total_net'] += parseInt(
          this.advtInvoiceData[index]['second_week_amount']
        );
        showData['total_cgst'] += parseInt(
          this.advtInvoiceData[index]['second_week_cgst']
        );
        showData['total_sgst'] += parseInt(
          this.advtInvoiceData[index]['second_week_sgst']
        );
        showData['total_igst'] += parseInt(
          this.advtInvoiceData[index]['second_week_igst']
        );
        showData['total_amt'] += parseInt(
          this.advtInvoiceData[index]['second_week_total_amount']
        );
      } else if (
        this.advtInvoiceData[index]['third_week_id'] != null &&
        this.advtInvoiceData[index]['third_week_issue_name'] ===
        this.issueName &&
        this.issueDates.includes(
          this.advtInvoiceData[index]['third_week_issue_date']
        )
      ) {
        showData['issue_name'] =
          this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
        showData['thirdweek_issue_date'] =
          this.advtInvoiceData[index]['third_week_issue_date'].split(',')[0];
        showData['total_advt_amt'] += parseInt(
          this.advtInvoiceData[index]['third_week_advt_amt']
        );
        showData['total_dis'] += parseInt(
          this.advtInvoiceData[index]['third_week_advt_discnt']
        );
        showData['total_net'] += parseInt(
          this.advtInvoiceData[index]['third_week_amount']
        );
        showData['total_cgst'] += parseInt(
          this.advtInvoiceData[index]['third_week_cgst']
        );
        showData['total_sgst'] += parseInt(
          this.advtInvoiceData[index]['third_week_sgst']
        );
        showData['total_igst'] += parseInt(
          this.advtInvoiceData[index]['third_week_igst']
        );
        showData['total_amt'] += parseInt(
          this.advtInvoiceData[index]['third_week_total_amount']
        );
      } else if (
        this.advtInvoiceData[index]['fourth_week_id'] != null &&
        this.advtInvoiceData[index]['fourth_week_issue_name'] ===
        this.issueName &&
        this.issueDates.includes(
          this.advtInvoiceData[index]['fourth_week_issue_date']
        )
      ) {
        showData['issue_name'] =
          this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
        showData['fourthweek_issue_date'] =
          this.advtInvoiceData[index]['fourth_week_issue_date'].split(',')[0];
        showData['total_advt_amt'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_advt_amt']
        );
        showData['total_dis'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_advt_discnt']
        );
        showData['total_net'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_amount']
        );
        showData['total_cgst'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_cgst']
        );
        showData['total_sgst'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_sgst']
        );
        showData['total_igst'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_igst']
        );
        showData['total_amt'] += parseInt(
          this.advtInvoiceData[index]['fourth_week_total_amount']
        );
      } else if (
        this.advtInvoiceData[index]['fifth_week_id'] != null &&
        this.advtInvoiceData[index]['fifth_week_issue_name'] ===
        this.issueName &&
        this.issueDates.includes(
          this.advtInvoiceData[index]['fifth_week_issue_date']
        )
      ) {
        showData['issue_name'] =
          this.advtInvoiceData[index]['first_week_issue_date'].spilt(',')[1];
        showData['fifthweek_issue_date'] =
          this.advtInvoiceData[index]['fifth_week_issue_date'].split(',')[0];
        showData['total_advt_amt'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_advt_amt']
        );
        showData['total_dis'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_advt_discnt']
        );
        showData['total_net'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_amount']
        );
        showData['total_cgst'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_cgst']
        );
        showData['total_sgst'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_sgst']
        );
        showData['total_igst'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_igst']
        );
        showData['total_amt'] += parseInt(
          this.advtInvoiceData[index]['fifth_week_total_amount']
        );
      }
      // }
      if (
        (this.advtInvoiceData[index]['first_week_issue_name'] ===
          this.issueName &&
          this.issueDates.includes(
            this.advtInvoiceData[index]['first_week_issue_date']
          )) ||
        (this.advtInvoiceData[index]['second_week_issue_name'] ===
          this.issueName &&
          this.issueDates.includes(
            this.advtInvoiceData[index]['second_week_issue_date']
          )) ||
        (this.advtInvoiceData[index]['third_week_issue_name'] ===
          this.issueName &&
          this.issueDates.includes(
            this.advtInvoiceData[index]['third_week_issue_date']
          )) ||
        (this.advtInvoiceData[index]['fourth_week_issue_name'] ===
          this.issueName &&
          this.issueDates.includes(
            this.advtInvoiceData[index]['fourth_week_issue_date']
          )) ||
        (this.advtInvoiceData[index]['fifth_week_issue_name'] ===
          this.issueName &&
          this.issueDates.includes(
            this.advtInvoiceData[index]['fifth_week_issue_date']
          ))
      ) {
        showData['invoice_no'] = this.advtInvoiceData[0]['invoice_no'];
        showData['invoice_date'] = this.advtInvoiceData[0]['invoice_date'];
        showData['advt_name'] = this.advtInvoiceData[0]['advt_name'];
        showData['client_name'] = this.advtInvoiceData[0]['cust_name'];
        showData['rep_name'] = this.advtInvoiceData[0]['rep_name'];
        showData['off_rep_name'] = this.advtInvoiceData[0]['off_rep_name'];

        this.printShowData.push(showData);
      }

      // console.log('showData', showData);
      // }
      console.log('printShowData', this.printShowData);
      if (index == data.length - 1) {
        this.isLoading = false;
        this.filterPrintShowData();
      }
    }
  }
  calculateTotals() {
    this.totals = {
      first_week_amount: 0,
      second_week_amount: 0,
      third_week_amount: 0,
      fourth_week_amount: 0,
      fifth_week_amount: 0,
      first_week_cgst: 0,
      second_week_cgst: 0,
      third_week_cgst: 0,
      fourth_week_cgst: 0,
      fifth_week_cgst: 0,
      first_week_sgst: 0,
      second_week_sgst: 0,
      third_week_sgst: 0,
      fourth_week_sgst: 0,
      fifth_week_sgst: 0,
      first_week_igst: 0,
      second_week_igst: 0,
      third_week_igst: 0,
      fourth_week_igst: 0,
      fifth_week_igst: 0,
      pay_amt: 0,
      issue_selling_discount_amt: 0,
      net_amount: 0,
      gst_amount: 0,
      received_amt: 0,
      total_invoice_amt: 0,
    };

    for (const data of this.dataList) {
      this.totals.first_week_amount += +(data.first_week_amount || 0);
      this.totals.second_week_amount += +(data.second_week_amount || 0);
      this.totals.third_week_amount += +(data.third_week_amount || 0);
      this.totals.fourth_week_amount += +(data.fourth_week_amount || 0);
      this.totals.fifth_week_amount += +(data.fifth_week_amount || 0);

      this.totals.first_week_cgst += +(data.first_week_cgst || 0);
      this.totals.second_week_cgst += +(data.second_week_cgst || 0);
      this.totals.third_week_cgst += +(data.third_week_cgst || 0);
      this.totals.fourth_week_cgst += +(data.fourth_week_cgst || 0);
      this.totals.fifth_week_cgst += +(data.fifth_week_cgst || 0);

      this.totals.first_week_sgst += +(data.first_week_sgst || 0);
      this.totals.second_week_sgst += +(data.second_week_sgst || 0);
      this.totals.third_week_sgst += +(data.third_week_sgst || 0);
      this.totals.fourth_week_sgst += +(data.fourth_week_sgst || 0);
      this.totals.fifth_week_sgst += +(data.fifth_week_sgst || 0);

      this.totals.first_week_igst += +(data.first_week_igst || 0);
      this.totals.second_week_igst += +(data.second_week_igst || 0);
      this.totals.third_week_igst += +(data.third_week_igst || 0);
      this.totals.fourth_week_igst += +(data.fourth_week_igst || 0);
      this.totals.fifth_week_igst += +(data.fifth_week_igst || 0);

      this.totals.pay_amt += +(data.pay_amt || 0);
      this.totals.issue_selling_discount_amt += +(data.issue_selling_discount_amt || 0);
      this.totals.net_amount += +(data.net_amount || 0);
      this.totals.gst_amount += +(data.gst_amount || 0);
      this.totals.received_amt += +(data.received_amt || 0);
      this.totals.total_invoice_amt += +(data.total_invoice_amt || 0);
    }
  }

  filterPrintShowData() {
    let data = this.uniqueid(this.printShowData, (a) =>
      formatDate(a.invoice_date, 'MM', 'en-IN', 'GMT+0530')
    );
    // console.log(data);
    let totalAdvtAmt1 = 0;
    let totalDisAmt1 = 0;
    let totalNetAmt1 = 0;
    let totalCGST1 = 0;
    let totalSGST1 = 0;
    let totalIGST1 = 0;
    let totalInvoiceAmount1 = 0;
    for (let index = 0; index < data.length; index++) {
      let filteredData = this.printShowData.filter((a) => {
        return (
          formatDate(a.invoice_date, 'MM', 'en-IN', 'GMT+0530') ==
          formatDate(data[index]['invoice_date'], 'MM', 'en-IN', 'GMT+0530')
        );
      });
      // console.log(filteredData);
      let totalAdvtAmt = 0;
      let totalDisAmt = 0;
      let totalNetAmt = 0;
      let totalCGST = 0;
      let totalSGST = 0;
      let totalIGST = 0;
      let totalInvoiceAmount = 0;
      let issue_date = '';
      for (let i = 0; i < filteredData.length; i++) {
        totalAdvtAmt += parseInt(filteredData[index]['total_advt_amt']);
        totalDisAmt += parseInt(filteredData[index]['total_dis']);
        totalNetAmt += parseInt(filteredData[index]['total_net']);
        totalCGST += parseInt(filteredData[index]['total_cgst']);
        totalSGST += parseInt(filteredData[index]['total_sgst']);
        totalIGST += parseInt(filteredData[index]['total_igst']);
        totalInvoiceAmount += parseInt(filteredData[index]['total_amt']);
        issue_date = filteredData[index]['invoice_date'];
      }

      filteredData.push({
        issue_date,
        totalAdvtAmt,
        totalDisAmt,
        totalNetAmt,
        totalCGST,
        totalSGST,
        totalIGST,
        totalInvoiceAmount,
      });

      totalAdvtAmt1 += totalAdvtAmt;
      totalDisAmt1 += totalDisAmt;
      totalNetAmt1 += totalNetAmt;
      totalCGST1 += totalCGST;
      totalSGST1 += totalSGST;
      totalIGST1 += totalIGST;
      totalInvoiceAmount1 = totalInvoiceAmount;

      this.filteredPrintShowData.push(filteredData);
    }

    this.filteredPrintShowData.push({
      totalAdvtAmt1,
      totalDisAmt1,
      totalNetAmt1,
      totalCGST1,
      totalSGST1,
      totalIGST1,
      totalInvoiceAmount1,
    });

    console.log(this.filteredPrintShowData);
  }

  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');


    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }



  issuedatereturn(dates) {
    if (dates != null) {
      let returnissuedate = dates.split(',');
      return returnissuedate[0];
    } else {
      return null;
    }

  }
  print() {
    const originalTitle = document.title; // Store original title
    document.title = '';     // Set custom print title

    // Create a style tag for print-specific styles
    const style = document.createElement('style');
    style.innerHTML = `
      @media print {
        @page {
          size: A4;
          margin: 10mm;
        }
        .print-header {
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .print-footer {
          position: fixed;
          bottom: 10px;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 12px;
          color: gray;
        }
        .print-footer::after {
          content: "Page " counter(page) " of " counter(pages);
        }
        .no-print {
          display: none !important;
        }
      }
    `;

    document.head.appendChild(style); // Add style to the document

    setTimeout(() => {
      const printTrigger = document.getElementById('print-button');
      if (printTrigger) (printTrigger as HTMLElement).click();

      document.title = ''; // Restore original title after printing

      // document.head.removeChild(style); // Remove the style after printing
    }, 500); // Delay ensures styles apply before printing
  }


}
function printPage() {
  throw new Error('Function not implemented.');

}




